import { Fsm } from "little-fsm";
import * as m from 'mithril';

export default function handleRouting(fsm:Fsm<any>) {
    fsm.setStateChangeEffect((oldState, newState, eventName) => {
        console.info(`State changed from ${oldState?.key} to ${newState?.key}`);

        //let loadingData = newState.key.includes("fetching") || newState.key.includes("progressing");

        if(/*fsm.isBackAllowed() && loadingData == false &&*/ eventName != 'back') {
            if(oldState) {            
                window.history.pushState(newState, "", `?state=${newState.key}`);
                console.debug(`Pushed state ${newState.key}`)
            } else {    
                //history.replaceState(newState, "", `#${newState.key}`);        
                window.history.pushState(newState, "", `?state=${newState.key}`)
                console.debug(`Replaced state with ${newState.key}`)
            } 
        } else {
            console.info(`Did not push state ${newState.key} to history since back is not allowed`)
        }               
    });

    window.addEventListener('popstate', (event) => {
        console.debug("handling pop state event: ", event);
        console.debug("location.href: ", location.href);
        console.debug("history.state: ", history.state);

        let currState = fsm.getCurrentState();
        fsm.processSubstateEvent(currState, 'back', {});

        m.redraw();
    });
}